import { EqxLink as Link } from '@equinoxx/react'
const EqxContinuumFooterButton = (props: {
    children?: React.ReactNode
    text?: string
    url?: string
    icon?: string
    name?: string
    menu?: React.ReactNode
}) => {
    const name = props.name ?? (Math.random() + 1).toString(36).substring(7)
    const menuContent = props.menu
    const menu = menuContent ? (
        <ul id={'footer-actions-' + name} className="dropdown-menu dropdown-menu-dark dropup collapse">
            {menuContent}
        </ul>
    ) : (
        <></>
    )
    const innerContent = props.children ?? (
        <>
            <span className={'page-action-icon ' + props.icon}></span>{' '}
            <span className="d-none d-md-inline">{props.text}</span>
        </>
    )
    const content = (
        <>
            {!menuContent ? (
                <Link to={props.url ?? '#'} title={props.text}>
                    {innerContent}
                </Link>
            ) : (
                <a href="#" data-bs-toggle="dropdown" data-bs-target={'#footer-actions-' + name} title={props.text}>
                    {innerContent}
                </a>
            )}
            {menu}
        </>
    )
    return <li className={menuContent ? 'dropdown dropup' : ''}>{content}</li>
}
const EqxContinuumFooterMenuItem = (props: { url?: string; text: string; onClick?: React.MouseEventHandler }) => {
    return (
        <li>
            <Link className="dropdown-item" to={props.url ?? '#'} onClick={props.onClick}>
                {props.text}
            </Link>
        </li>
    )
}
interface EqxContinuumFooterProps {
    relatedLinks?: { url: string; text: string }[]
    children?: React.ReactNode
}
const EqxContinuumFooter = function (props: EqxContinuumFooterProps) {
    const footerRelatedLinks = props.relatedLinks || []
    if (footerRelatedLinks.length == 0) {
        footerRelatedLinks.push({ url: '/', text: 'Back to Home' })
    }
    return (
        <footer id="main">
            <ul id="footer-actions">{props.children}</ul>
        </footer>
    )
}
export { EqxContinuumFooter as default, EqxContinuumFooterButton, EqxContinuumFooterMenuItem }

